<ng-container *ngIf="items$ | async as items">
  <ng-container *ngIf="items.manuals as manuals">
    <mat-expansion-panel
      class="product-manual-panel"
      [ngClass]="activeLanguage$ | async"
      [style.display]="manuals.categorizedManualsList.length > 0 ? 'block' : 'none'"
    >
      <mat-expansion-panel-header class="pdp-manual-panel-header">
        <mat-panel-title #matPanelClick class="pdp-manual-label">
          {{ 'pdpManual.manualInstructionLabel' | cxTranslate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let manual of manuals.categorizedManualsList">
        <p class="pdp-manual-category">
          <span>{{ manual.categoryType }}</span>
          <ng-container *ngFor="let data of manual.manualsList.medias">
            <p>
              <app-generic-link
                [target]="'_blank'"
                [ngClass]="data.styleClass"
                [url]="data.media"
                [style]="data.styleAttributes"
                >{{ data.title }}</app-generic-link
              >
            </p>
          </ng-container>
        </p>
      </ng-container>
    </mat-expansion-panel>
  </ng-container>
</ng-container>
